import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import MaterialBreadcrumbs from '@mui/material/Breadcrumbs';
import MaterialLink from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { styled } from '@mui/material/styles';
import LinkBehavior from '@components/Shared/LinkBehavior';
import useBreadcrumbs from './useBreadcrumbs';
import useMobileActiveMenu from '../components/useMobileActiveMenu';
import { useCallback } from 'react';
import useIsMobile from '../components/useIsMobile';
import { GetAccountSettings } from '@themes/common/data';
const { general_accessibility_menu, general_accessibility_start } = GetAccountSettings().translations;
const LinkItem = styled((props) => _jsx(MaterialLink, Object.assign({ component: LinkBehavior }, props, { underline: 'hover', color: 'inherit' })))(({ theme }) => ({
    padding: theme.spacing(1),
    fontSize: '0.8rem',
}));
const Breadcrumbs = styled(MaterialBreadcrumbs)(({ theme }) => ({
    '.MuiBreadcrumbs-separator': {
        margin: 0,
    },
    '.MuiSvgIcon-root': {
        width: 'auto',
    },
    '.MuiLink-root': {
        padding: 0,
    },
    '.MuiBreadcrumbs-li': {
        display: 'flex',
        alignItems: 'center',
    },
}));
export default function AccountBreadcrumbs() {
    const isMoble = useIsMobile();
    const [{ mainLink, extraLinks }] = useBreadcrumbs();
    const [mobileMenuActiveState, setActive] = useMobileActiveMenu();
    const handleClearMobileActive = useCallback(() => {
        setActive((state) => {
            state.activePath = null;
        });
    }, [setActive]);
    return !isMoble || (isMoble && mobileMenuActiveState.activePath) ? (_jsxs(Breadcrumbs, Object.assign({ separator: _jsx(NavigateNextIcon, { fontSize: 'small' }), "aria-label": 'breadcrumb', sx: {
            backgroundColor: '#fff',
            position: 'absolute',
            paddingX: '8px',
            borderRadius: '5px',
            bottom: 10,
            left: 10,
            display: 'flex',
            alignItems: 'center',
        } }, { children: [_jsx(LinkItem, Object.assign({ href: '/account', onClick: handleClearMobileActive }, { children: isMoble ? general_accessibility_menu : general_accessibility_start })), _jsx(LinkItem, Object.assign({ href: mainLink.href, sx: extraLinks.length ? undefined : { fontWeight: 600, color: '#000' } }, { children: mainLink.text })), extraLinks.map((link, index) => (_jsx(LinkItem, Object.assign({ href: mainLink.href, sx: extraLinks.length - 1 === index ? { fontWeight: 600, color: '#000' } : undefined }, { children: link.text }), link.href)))] }))) : (_jsx(_Fragment, {}));
}
